import { Box, VStack, UnorderedList, ListItem, Button, Image, Stack, Text } from '@chakra-ui/react';
import React from 'react';
import { useLocation, NavLink, useNavigate } from 'react-router-dom';
import { IMG, Menu } from '../../../Content/Content';

const Menubar = () => {
    const navigate = useNavigate()
    return (
        <VStack background="#F5F5F5" minH="62px" boxShadow="0px 2px 3px rgba(0, 0, 0, 0.25);" borderRadius="6px 0px 6px 6px" className='dashboard_menu'>
            <Box className="d-flex justify-content-between align-items-center w-100 px-4">
                <Box w="70%">
                    <UnorderedList className="nav justify-content-start">
                        {
                            Menu.map((item, index) => {
                                return (
                                    <ListItem className="nav-link" textTransform="capitalize" key={index}>
                                        <NavLink to={item.url} className="nav-link">
                                            {item.name}
                                        </NavLink>
                                    </ListItem>
                                )
                            })
                        }
                    </UnorderedList>
                </Box>

                <Box w="30%">
                    <Stack flexDirection="row" justifyContent="end" alignItems="center">
                        <Box textAlign="right" paddingX="20px">
                            <Text fontSize="14px" fontWeight="500" textAlign="right">Sabtain Haider</Text>
                            <Button type='button' onClick={()=>navigate("/dashboard/pricing")}>
                                <Text fontSize="12px" fontWeight="400" textAlign="right">200 Credits</Text>
                            </Button>

                        </Box>
                        <Box>
                            <Image src={IMG.avater} />
                        </Box>
                    </Stack>


                </Box>
            </Box>
        </VStack>
    );
};

export default Menubar;